<!-- src/app/adjustments-admin/adjustments-admin.component.html -->
<button nz-button nzType="primary" (click)="openCreate()" style="margin-bottom:12px;">New Adjustment</button>

<nz-modal
  [(nzVisible)]="showCreateModal"
  [nzFooter]="null"
  [nzClosable]="true"
  [nzMaskClosable]="false"
  [nzWrapClassName]="'fullscreen-modal'">
  <ng-container *nzModalContent>

    <div style="display:flex; gap:16px; align-items:flex-end; flex-wrap:wrap;">
      <!-- Payer -->
      <nz-radio-group [(ngModel)]="form.payer.type">
        <label nz-radio nzValue="company">Company pays</label>
        <label nz-radio nzValue="user">User pays</label>
      </nz-radio-group>

      <nz-select *ngIf="form.payer.type==='company'"
           [(ngModel)]="form.payer.company_id"
           nzShowSearch nzPlaceHolder="Select company" style="min-width:240px;">
  <nz-option *ngFor="let c of companies" [nzValue]="c.id" [nzLabel]="c.name"></nz-option>
</nz-select>

      <nz-select *ngIf="form.payer.type==='user'" [(ngModel)]="form.payer.id"
                 nzShowSearch nzPlaceHolder="Select payer user" style="min-width:240px;">
        <nz-option *ngFor="let u of users" [nzValue]="u.id" [nzLabel]="u.label"></nz-option>
      </nz-select>

      <!-- Payee -->
      <nz-select [(ngModel)]="form.payee_user_id" nzShowSearch nzPlaceHolder="Select payee user" style="min-width:240px;">
        <nz-option *ngFor="let u of users" [nzValue]="u.id" [nzLabel]="u.label"></nz-option>
      </nz-select>

      <!-- Basic fields -->
      <nz-input-group nzAddOnBefore="Category">
        <input nz-input [(ngModel)]="form.category" />
      </nz-input-group>
      <nz-input-group nzAddOnBefore="Reason">
        <input nz-input [(ngModel)]="form.reason" />
      </nz-input-group>
      <nz-input-group nzAddOnBefore="Notes">
        <input nz-input [(ngModel)]="form.notes" />
      </nz-input-group>
      <nz-input-group nzAddOnBefore="Amount">
        <input nz-input type="number" [(ngModel)]="form.amount" />
      </nz-input-group>
      <nz-date-picker [(ngModel)]="form.payout_date" nzPlaceHolder="Payout date"></nz-date-picker>
    </div>

    <nz-divider></nz-divider>
    <h3>Recovery Terms</h3>
    <div style="display:flex; gap:16px; align-items:flex-end; flex-wrap:wrap;">
      <nz-radio-group [(ngModel)]="form.recovery.strategy">
        <label nz-radio nzValue="split">Split over intervals</label>
        <label nz-radio nzValue="first_eligible">First eligible commissions</label>
      </nz-radio-group>

      <nz-input-group nzAddOnBefore="Min take-home">
        <input nz-input type="number" [(ngModel)]="form.min_take_home" />
      </nz-input-group>

      <nz-input-group nzAddOnBefore="Max per cycle">
        <input nz-input type="number" [(ngModel)]="form.max_per_cycle" />
      </nz-input-group>

      <nz-select [(ngModel)]="form.recovery_destination" nzPlaceHolder="Recovery pays back to" style="min-width:240px;">
        <nz-option nzValue="original_payer" nzLabel="Original payer"></nz-option>
        <nz-option nzValue="other_user" nzLabel="Another user"></nz-option>
      </nz-select>

      <nz-select *ngIf="form.recovery_destination==='other_user'" [(ngModel)]="form.recovery_destination_user_id"
                 nzShowSearch nzPlaceHolder="Select destination user" style="min-width:240px;">
        <nz-option *ngFor="let u of users" [nzValue]="u.id" [nzLabel]="u.label"></nz-option>
      </nz-select>
    </div>

    <!-- Split schedule -->
    <div *ngIf="form.recovery.strategy==='split'" style="margin-top:12px;">
      <nz-input-group nzAddOnBefore="# intervals">
        <input nz-input type="number" [(ngModel)]="splitIntervals" />
      </nz-input-group>
      <nz-date-picker [(ngModel)]="splitStartDate" nzPlaceHolder="First recovery date"></nz-date-picker>
      <button nz-button (click)="autoSplit()">Auto-split</button>

      <nz-table [nzData]="form.recovery.schedule" style="margin-top:8px;">
        <thead>
          <tr><th>Date</th><th>Amount</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of form.recovery.schedule; let i = index">
            <td><nz-date-picker [(ngModel)]="s.date"></nz-date-picker></td>
            <td>
              <nz-input-group nzAddOnBefore="$">
                <input nz-input type="number" [(ngModel)]="s.amount" (ngModelChange)="recomputeRemaining()" />
              </nz-input-group>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <div>Remaining to allocate: {{ remainingToAllocate() | currency }}</div>
    </div>

    <!-- First eligible options -->
    <div *ngIf="form.recovery.strategy==='first_eligible'" style="margin-top:12px;">
      <nz-date-picker [(ngModel)]="form.recovery.earliest_date" nzPlaceHolder="Earliest recovery date"></nz-date-picker>
    </div>

    <div style="margin-top:16px; display:flex; gap:8px; justify-content:flex-end;">
      <button nz-button (click)="handleCreateCancel()">Cancel</button>
      <button nz-button nzType="primary" (click)="handleCreateOk()" [nzLoading]="isLoading">Create</button>
    </div>

  </ng-container>
</nz-modal>

<nz-divider></nz-divider>
<h3 style="margin:8px 0;">Adjustments</h3>
<div style="display:flex; gap:8px; align-items:center; margin-bottom:8px;">
  <button nz-button (click)="refresh()">Refresh</button>
  <nz-input-group nzAddOnBefore="Search" style="min-width:320px;">
    <input nz-input [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()" placeholder="Payee, payer, category, notes, strategy..." />
  </nz-input-group>
</div>

<nz-table #table
          [nzData]="displayData"
          [nzFrontPagination]="true"
          [nzPageSize]="pageSize"
          [nzPageIndex]="pageIndex"
          [nzShowSizeChanger]="true"
          [nzPageSizeOptions]="[10,20,50,100]"
          (nzPageIndexChange)="pageIndex=$event"
          (nzPageSizeChange)="pageSize=$event; pageIndex=1">
  <thead>
    <tr>
      <th (click)="setSort('created_at')" style="cursor:pointer;">Created</th>
      <th style="cursor:default;">Label</th>
      <th (click)="setSort('amount')" style="cursor:pointer;">Amount</th>
      <th (click)="setSort('status')" style="cursor:pointer;">Status</th>
      <th (click)="setSort('payout_date')" style="cursor:pointer;">Payout Date</th>
      <th (click)="setSort('strategy')" style="cursor:pointer;">Strategy</th>
      <th (click)="setSort('type')" style="cursor:pointer;">Type</th>
      <th (click)="setSort('payee')" style="cursor:pointer;">Payee</th>
      <th (click)="setSort('payer')" style="cursor:pointer;">Payer</th>
      <th (click)="setSort('planned_date')" style="cursor:pointer;">Planned Recovery Date</th>
      <th>Notes</th>
      <th (click)="setSort('remaining')" style="cursor:pointer;">Remaining</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let a of table.data">
      <td>{{ a.created_at | date:'yyyy-MM-dd HH:mm' }}</td>
      <td>{{ 'Adjustment – ' + (a.details?.category || 'Adjustment') + (a.details?.notes ? (' - ' + a.details.notes) : '') }}</td>
      <td>{{ a.amount | currency }}</td>
      <td>{{ displayStatus(a) }}</td>
      <td>{{ a.details?.payout_date | date }}</td>
      <td>{{ a.details?.recovery?.strategy || a.strategy || 'n/a' }}</td>
      <td>{{ a.entry_kind || 'payout' }}</td>
      <td>{{ userLabel(a.details?.payee_user_id) }}</td>
      <td>
        <ng-container *ngIf="a.details?.payer?.type === 'user'">{{ userLabel(a.details?.payer?.id) }}</ng-container>
        <ng-container *ngIf="a.details?.payer?.type === 'company'">{{ companyLabel(a.details?.payer?.company_id) }}</ng-container>
      </td>
      <td>
        <ng-container *ngIf="a.strategy === 'split'">{{ a.planned_date | date }}</ng-container>
        <ng-container *ngIf="a.strategy === 'first_eligible'">{{ a.planned_date | date }}</ng-container>
      </td>
      <td>{{ a.details?.notes || '' }}</td>
      <td>
        <ng-container *ngIf="a.entry_kind === 'recovery'; else noRem">
          {{ (a.remaining_amount ?? a.details?.recovery?.remaining_amount) | currency }}
        </ng-container>
        <ng-template #noRem>–</ng-template>
      </td>
    </tr>
  </tbody>
</nz-table>